import useWidget from './useWidget.js';
const useWidgetActions = () => {
    return useWidget().actions;
};
export default useWidgetActions;
